import axios from "axios";
import { useState, useEffect } from "react";
import { EnvGet } from '../../utils/EnvGet';

function useAxios(url, method = 'get', postData = {}) {
	const [data, setData] = useState(null);
	const [isPending, setIsPending] = useState(true);
	const [error, setError] = useState(null);
	
	// Created baseUrl for all the API requests
	const instance = axios.create({
		baseURL: EnvGet()
	});

	useEffect(() => {
		const abortController = new AbortController();
		const postDataObject = { data: postData, signal: abortController.signal };

		(async () => {
			try {
				let response;
				if (method === 'get') {
					response = await instance.get(url, { signal: abortController.signal });
				}
				if (method === 'post') {
					response = await instance.post(url, postDataObject);
				}
				if (response.status !== 200) {
					throw Error('Could not fetch the data for that source...');
				}
				setData(response.data);
				setIsPending(false);
			} catch (error) {
				if (error.name === 'AbortError') {
					throw Error('Fetch Aborted to avoid error due to component unloaded...');
				}
				setIsPending(false);
				setError(error.message);
			}
		})();

		// Used AbortController to unknown avoid error when component unmount during API request
		return () => abortController.abort();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [url, method]);

	return { data, isPending, error };
}

export default useAxios;